import { FC, Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Toolbar } from '@mui/material'
import { Header } from 'components/features/home/Header'
import { Sidebar } from 'components/features/home/Sidebar'
import { Loader } from 'components/shared/Loader'
import { withAuthOnly } from 'hocs/withAuthOnly'
import { useSyncLayout } from 'hooks/useSyncLayout'
import { useAppDispatch, useAppSelector } from 'store'
import { setDrawerIsOpen } from 'store/ui/actions'
import { selectUIDrawer } from 'store/ui/selectors'

const MainLayoutInternal: FC = () => {
  const dispatch = useAppDispatch()

  const { isOpen: drawerIsOpen } = useAppSelector(selectUIDrawer)

  const toggleDrawer = () => {
    dispatch(setDrawerIsOpen(!drawerIsOpen))
  }

  useSyncLayout()

  return (
    <Box sx={{ display: 'flex' }}>
      <Header isOpen={drawerIsOpen} toggleDrawer={toggleDrawer} />
      <Sidebar isOpen={drawerIsOpen} toggleDrawer={toggleDrawer} />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Toolbar />
        <Box sx={{ p: 4, flex: '1 0 auto' }}>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </Box>
  )
}

export const MainLayout = withAuthOnly(MainLayoutInternal)
